export const CLINIC = {
  name: "Mom and More Clinic",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_gyn-clinic-yasmeen/artifacts/jg33o3it_WhatsApp%20Image%202026-09-03%20at%2013.15.52.jpeg",
  doctor: "Dr. Yasmin Imdad",
  doctorShort: "Dr. Yasmin",
  credentials: "MBBS, DGO, DNB, MRCOG (London), MRCPI (Ireland), MICOG, FMAS, FRM",
  credentialsShort: "MRCOG (London) · MRCPI (Ireland)",
  role: "Senior Consultant — Obstetrics & Gynaecology",
  subSpecialties: "Fertility (Reproductive Medicine) · Aesthetic Gynaecology",
  experience: "25 years",
  affiliations: "Also practises at Rainbow Children's Hospital / BirthRight by Rainbow",
  shortBio:
    "Dr. Yasmin Imdad is a Senior Consultant Obstetrician & Gynaecologist with 25 years of practice, specialising in fertility and aesthetic gynaecology. Holding MRCOG (London) and MRCPI (Ireland), she brings dual international accreditation to every consultation.",
  mediumBio:
    "Dr. Yasmin Imdad is a Senior Consultant in Obstetrics & Gynaecology with 25 years of clinical experience. Her practice spans antenatal and high-risk pregnancy care, fertility and reproductive medicine, minimal access gynaecological surgery, and aesthetic gynaecology. She is a Member of the Royal College of Obstetricians & Gynaecologists, London (MRCOG) and of the Royal College of Physicians of Ireland (MRCPI), alongside MBBS, DGO, DNB, MICOG, FMAS and FRM. Beyond the clinic, Dr. Yasmin teaches — creating structured pregnancy education for expectant parents and exam preparation for doctors sitting the MRCOG.",
  address: "112, Arcade, Whitefield Road, Brigade Metropolis, Garudachar Palya, Mahadevapura, Bengaluru, Karnataka 560048",
  phone: "089711 80222",
  email: "momandmoreclinic@gmail.com",
  rating: { score: "5.0", reviews: "180" },
  hours: [
    { d: "Monday – Saturday", t: "5:00 PM – 8:00 PM" },
    { d: "Sunday", t: "By appointment" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Mom+and+More+Clinic+Brigade+Metropolis+Mahadevapura+Bengaluru&output=embed",
  mapLink: "https://share.google/EdmfxSymjMUVh5aUg",
};

export const IMAGES = {
  portrait:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_gyn-clinic-yasmeen/artifacts/h6zheq6j_de5f341e-2c50-45a5-bae3-fba40cfd5c3c.JPG",
  slideshow: [
    "https://customer-assets-cm19k8pv.emergentagent.net/job_gyn-clinic-yasmeen/artifacts/7exj9efq_1.webp",
    "https://customer-assets-cm19k8pv.emergentagent.net/job_gyn-clinic-yasmeen/artifacts/piagh98m_2.webp",
    "https://customer-assets-cm19k8pv.emergentagent.net/job_gyn-clinic-yasmeen/artifacts/gk5m6vem_4.webp",
  ],
  clinic:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_gyn-clinic-yasmeen/artifacts/l33fdnqt_5.webp",
  care:
    "https://images.unsplash.com/photo-1542385151-efd9000785a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxtb3RoZXIlMjBiYWJ5fGVufDB8fHx8MTc4NTg5NjI3MXww&ixlib=rb-4.1.0&q=85",
  texture:
    "https://images.unsplash.com/photo-1657624332868-2159deacefa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHNvZnQlMjBwaW5rJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODU4OTYyNjN8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  { title: "Prenatal & Antenatal Care", desc: "Comprehensive pregnancy journeys with regular monitoring, nutrition and reassurance at every trimester." },
  { title: "High-Risk Pregnancy", desc: "Specialised, closely-monitored care for complex pregnancies, keeping mother and baby safe." },
  { title: "Gynaecology & Well-Woman", desc: "Routine screenings, infections, PCOS and preventive care tailored to every stage of womanhood." },
  { title: "Fertility & PCOS", desc: "Evidence-based fertility guidance and hormonal balance support with a gentle, unhurried approach." },
  { title: "Menopause Care", desc: "Compassionate management of the transition, from symptom relief to long-term bone and heart health." },
  { title: "Adolescent Health", desc: "A safe, judgement-free space for young women's first conversations about their bodies." },
];

export const MANIFESTO = [
  { n: "01", title: "Listen first, always", body: "Every consultation begins with your story. We make room for questions, fears and the small details that matter — because good medicine starts with truly being heard." },
  { n: "02", title: "Evidence with empathy", body: "Decisions are grounded in the latest clinical evidence, explained in plain language, so you feel informed and in control of your own care." },
  { n: "03", title: "Care beyond the clinic", body: "From your first visit to years after, we stay a steady presence — a place you can return to for every chapter of your health." },
];

export const STORIES = [
  { name: "Priya S.", treatment: "Antenatal Care", quote: "Dr. Yasmin made my first pregnancy feel calm and safe. She never rushed a single question and I always left feeling reassured." },
  { name: "Fatima R.", treatment: "Fertility & PCOS", quote: "After years of confusion, she finally explained things clearly and gave me a plan that actually worked. I'm now a mother." },
  { name: "Anitha M.", treatment: "High-Risk Pregnancy", quote: "My pregnancy was complicated, but her steady, honest guidance got us both through it safely. Forever grateful." },
  { name: "Sneha K.", treatment: "Well-Woman Care", quote: "The most respectful and thorough gynaec I've ever visited. The consultation feels private, warm and genuinely caring." },
];

export const SERVICE_OPTIONS = [
  "Prenatal / Antenatal Care",
  "High-Risk Pregnancy",
  "Gynaecology / Well-Woman",
  "Fertility & PCOS",
  "Menopause Care",
  "Adolescent Health",
  "General Consultation",
];
